import React from "react";
import styled from "styled-components";

export const IconBadge = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
`;

export const StyledIcon = styled.img`
  width: 34px;
  height: 34px;
  background-repeat: no-repeat;
  background-size: contain;
  filter: invert(100%);
`;

export const MyComponent = ({ iconName }) => {
  return (
    <IconBadge>
      <StyledIcon src={iconName} />
    </IconBadge>
  );
};

export default MyComponent;

/*
export const IconContainer = styled.div`
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: currentColor;
`;

///Users/benguozbek/Documents/GitHub/sms23/src/assets/instagram.svg
//const iconPath = `../assets/${name}.svg`;
export const Icon = ({ name, color, size }) => {
  const iconPath = `../../assets/${name}.svg`;

  const IconSvg = React.lazy(() => import(`${iconPath}`));
  return (
    <IconContainer style={{ color: color, fontSize: size }}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <IconSvg viewBox="0 0 24 24" />
      </React.Suspense>
    </IconContainer>
  );
};

export default Icon;
*/
